import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';
import { Bell, Mail, Phone, Save, Send, Loader2 } from 'lucide-react';

const TeamAlertsTab = ({
  teamAlerts, toggleAlert, savingAlerts, saveTeamAlerts,
  digestConfig, setDigestConfig, savingDigest, saveDigestConfig,
  sendingDigestNow, sendDigestNow
}) => (
  <>
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle className="flex items-center gap-2"><Bell className="h-5 w-5 text-[#E8722A]" />Team Activity Alerts</CardTitle>
          <CardDescription>Get notified via Email or SMS when Team Members take actions on candidates</CardDescription>
        </div>
        <Button onClick={saveTeamAlerts} disabled={savingAlerts} className="bg-[#E8722A] hover:bg-[#D6621F]" data-testid="save-team-alerts-btn">
          <Save className="mr-2 h-4 w-4" />{savingAlerts ? 'Saving...' : 'Save Alerts'}
        </Button>
      </CardHeader>
      <CardContent>
        <div className="space-y-1">
          {[
            { key: 'candidate_approved', label: 'Candidate Approved / Moved Forward', desc: 'When a team member approves a candidate' },
            { key: 'candidate_declined', label: 'Candidate Declined', desc: 'When a team member declines a candidate' },
            { key: 'candidate_hired', label: 'Candidate Hired', desc: 'When a team member marks someone as hired' },
            { key: 'offer_letter_sent', label: 'Offer Letter Sent', desc: 'When a team member sends an offer letter' },
            { key: 'background_check', label: 'Background Check Action', desc: 'When a team member initiates or updates a background check' },
            { key: 'rating_changed', label: 'Rating Changed', desc: 'When a team member changes a candidate rating' },
            { key: 'candidate_viewed', label: 'Candidate Viewed', desc: 'When a team member opens a candidate profile' },
            { key: 'job_modified', label: 'Job Listing Modified', desc: 'When a team member creates/edits a job listing' },
            { key: 'other_action', label: 'Other Actions', desc: 'Notes added, interview scheduled, etc.' },
          ].map(({ key, label, desc }) => (
            <div key={key} className="flex items-center justify-between p-4 border-b last:border-b-0" data-testid={`alert-row-${key}`}>
              <div className="flex-1"><p className="font-medium text-[#333]">{label}</p><p className="text-sm text-[#666]">{desc}</p></div>
              <div className="flex items-center gap-6">
                <div className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#666]" /><Switch checked={teamAlerts[key]?.email || false} onCheckedChange={() => toggleAlert(key, 'email')} data-testid={`alert-${key}-email`} /></div>
                <div className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#666]" /><Switch checked={teamAlerts[key]?.sms || false} onCheckedChange={() => toggleAlert(key, 'sms')} data-testid={`alert-${key}-sms`} /></div>
              </div>
            </div>
          ))}
        </div>
        <p className="text-xs text-[#999] mt-4">You will only be notified of Team Member actions — not your own. SMS alerts require a verified phone number.</p>
      </CardContent>
    </Card>

    <Card className="mt-6">
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle className="flex items-center gap-2"><Mail className="h-5 w-5 text-[#4B2D6E]" />Weekly Activity Digest</CardTitle>
          <CardDescription>Receive a summary email of all team activity from the past 7 days</CardDescription>
        </div>
        <div className="flex items-center gap-3">
          <Switch checked={digestConfig.enabled} onCheckedChange={(val) => setDigestConfig(prev => ({ ...prev, enabled: val }))} data-testid="digest-enabled-toggle" />
          <span className="text-sm font-medium text-[#333]">{digestConfig.enabled ? 'On' : 'Off'}</span>
        </div>
      </CardHeader>
      {digestConfig.enabled && (
        <CardContent className="space-y-5">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Send Day</Label>
              <select value={digestConfig.day} onChange={(e) => setDigestConfig(prev => ({ ...prev, day: e.target.value }))} className="w-full border rounded-md px-3 py-2 text-sm" data-testid="digest-day-select">
                {['monday','tuesday','wednesday','thursday','friday','saturday','sunday'].map(d => <option key={d} value={d}>{d.charAt(0).toUpperCase() + d.slice(1)}</option>)}
              </select>
            </div>
            <div className="space-y-2"><Label>Send Time</Label><Input type="time" value={digestConfig.time} onChange={(e) => setDigestConfig(prev => ({ ...prev, time: e.target.value }))} data-testid="digest-time-input" /></div>
          </div>
          {digestConfig.last_sent && <p className="text-xs text-[#999]">Last sent: {new Date(digestConfig.last_sent).toLocaleString()}</p>}
          <div className="flex gap-3">
            <Button onClick={saveDigestConfig} disabled={savingDigest} className="bg-[#E8722A] hover:bg-[#D6621F]" data-testid="save-digest-btn"><Save className="mr-2 h-4 w-4" />{savingDigest ? 'Saving...' : 'Save Schedule'}</Button>
            <Button onClick={sendDigestNow} disabled={sendingDigestNow} variant="outline" className="border-[#4B2D6E] text-[#4B2D6E]" data-testid="send-digest-now-btn">
              {sendingDigestNow ? (<><Loader2 className="mr-2 h-4 w-4 animate-spin" />Sending...</>) : (<><Send className="mr-2 h-4 w-4" />Send Now</>)}
            </Button>
          </div>
        </CardContent>
      )}
    </Card>
  </>
);

export { TeamAlertsTab };
